// Preço unitário do abastecimento (campo `price` que a ConectTec devolve no
// /last-fillins) mostrado sempre com 2 casas, arredondando meio centavo para cima:
// R$ 5,885 vira R$ 5,89 e R$ 5,884 vira R$ 5,88. Só exibição: o payload da
// pontuação continua levando o `price` original, sem arredondar.
//
// `toFixed(2)` não serve: 5.885 em ponto flutuante é 5,88499..., e ele devolve
// "5.88". Multiplicar por 100 dá o mesmo problema (1.005 * 100 = 100,49999...).
// Por isso o valor escalado é aparado em 7 dígitos significativos antes do
// arredondamento, o que tira o ruído do float (inclusive o de float4, que é como
// `fillin.price_per_liter` fica guardado) sem mexer em preço de até 5 casas.
export const roundToCents = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') { return null; }
  const number = Number(value);
  if (!Number.isFinite(number)) { return null; }
  const cents = Number((Math.abs(number) * 100).toPrecision(7));
  return (Math.sign(number) * Math.round(cents)) / 100;
};

const currency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Sem preço válido mostra traço: inventar a partir de total/volume daria um
// número que a bomba não cobrou (o concentrador às vezes trunca essa conta).
export const formatUnitPrice = (value: unknown): string => {
  const rounded = roundToCents(value);
  return rounded === null ? '—' : currency.format(rounded);
};
